<template>
  <!-- 订单新增与修改弹窗-->
  <div class="orderInfoAD">
    <div v-show="false" id="container" />
    <el-row :gutter="20">
      <div class="bg-purple bcGrey">
        <el-form ref="form" label-position="left" label-width="auto" class="grey padding10">
          <el-tabs v-model="ordMain.zdelivery" class="marginBottom10 marginLeft10">
              <el-tab-pane label="同城配送" name="0" />
              <el-tab-pane label="顾客自提" name="1"/>
            </el-tabs>
          <el-form-item label="线上店铺">
            <el-input v-model="ordMain.sshop" type="text" style="width: 270px;" readonly></el-input>
          </el-form-item>
          <el-form-item label="配送/自提门店">
              <template slot="label">
                <span style="color: red;">*</span>配送/自提门店
              </template>
              <el-select v-model="store" placeholder="请选择配送门店" @change="handleSelectStore" filterable>
                <el-option v-for="item in storeList" :key="item.sid" :label="item.cname" :value="item.sid"></el-option>
              </el-select>
            </el-form-item>
          <el-form-item label="选择城市">
            <el-cascader v-model="address" :options="options" :props="defaultProps" @change="selectCity" />
          </el-form-item>
          <el-form-item v-if="ordMain.zdelivery === '0'" label="收货地址">
            <el-select v-model="ordMain.ccustomerAddr" clearable filterable :filter-method="getReceivingAddress" placeholder="请选择" @change="changeInfo">
              <el-option v-for="item in infoOptions" :key="item.id" :label="item.name" :value="item">
                <div class="flex directionColumn">
                  <div>{{ item.name }}</div>
                  <div class="grey">{{ item.address }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址">
            <template slot="label">
              <span style="color: red;">*</span>详细地址
            </template>
            <el-input v-model="ordMain.creceiveAddr" type="textarea" style="width: 270px;"></el-input>
          </el-form-item>
          <el-form-item label="收货人" prop="ccustomerName">
            <template slot="label">
              <span style="color: red;">*</span>收货人
            </template>
            <el-input v-model="ordMain.ccustomerName"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="ccustomerPhone">
            <template slot="label">
              <span style="color: red;">*</span>手机号
            </template>
            <el-input v-model="ordMain.ccustomerPhone" class="w150"></el-input>
          </el-form-item>
          <el-form-item label="用户备注" class="marginTop10">
              <el-input v-model="ordMain.corderRemark" autosize type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="内部备注" class="marginTop10">
              <el-input v-model="ordMain.cremark" autosize type="textarea"></el-input>
            </el-form-item>
          <el-form-item label="" >
            <span>门店与商品信息请在拣货单中修改</span>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-row type="flex" justify="end">
      <el-button type="primary" plain @click="submit">提交</el-button>
    </el-row>
  </div>
</template>

<script>
import lodash from "lodash";
import moment from "moment";

export default {
  name: "OrderInfo",
  props: {
    orderInfo: {
      type: Object,
      default: function() {
        return {}
      }
    },
  },
  data() {
    return {
      infoOptions: [],
      url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      address: [],
      ordMain: {
        zdelivery: '0',
        sshop: '',
        ccustomerName: '',
        ccustomerPhone: '',
        creceiveAddr: '',
        ccustomerAddr: '',
        caddrLongitude: '',
        caddrLatitude: '',
        tarriveReq: '',
        corderRemark: '',
        cremark: '',
        sstore: '',
        rstore: '',
        storeLongitude: '',

      },
      value: '福州市',
      value1: '',
      startTime: '',
      endTime: '',
      options: [],
      defaultProps: {
        children: "children",
        label: "NODE_NAME",
        value: "NODE_CODE",
      },
      store: '',
      storeList: []
    };
  },
  created() {
    this.queryBaseAreaList();
    this.selectOrderById();
  },
  methods: {
    handleSelectStore(val) {
      let store = lodash.filter(this.storeList, { sid: val })[0];
      this.ordMain.sstore = store.cname;
      this.ordMain.rstore = store.sid;
    },
    queryStore(orderId, ccity) {
      this.topsAjax.get(`${this.baseUrls.third}/query/store/list`, { orderId, ccity}).then((res) => {
        this.storeList = res;
        if (this.storeList.length === 1) {
          let id = this.storeList[0].sid;
          this.handleSelectStore(id);
          this.store = id;
        }
      });
    },
    submit() {
      if (this.ordMain.rstore === undefined || this.ordMain.rstore === '') {
        this.$message.success("请选择门店。");
        return;
      }
      let url = `${this.baseUrls.third}/update`;
      this.topsAjax.post(url, this.ordMain).then(() => {
        this.$message.success("保存完成");
        this.$emit("handleClose");
      });
    },
    queryBaseAreaList() {
      let url = `${this.baseUrls.baseArea}/queryList`;
      this.topsAjax.get(url).then((res) => {
        res.forEach((item) => {
          if (item.children) {
            item.children.forEach((subItem) => {
              if (subItem.children) {
                delete subItem.children;
              }
            });
          }
        });
        this.options = res;
      });
    },
    selectCity(val) {
      this.infoOptions = [];
      let city;
      this.options.forEach((item) => {
        if (item.children) {
          item.children.forEach((subItem) => {
            if (subItem.NODE_CODE === val[1]) city = subItem;
          });
        }
      });
      if (city) {
        let search = city.NODE_NAME !== "市辖区" ? city.NODE_NAME : city.PROVINCE_NAME;
        this.value = search;
      }
    },
    getArrivePre() {
      if (this.value1 !== "" && this.value1 !== null && this.startTime !== "" && this.startTime !== null && this.endTime !== "" && this.endTime !== null) {
        let startDay = moment(this.value1, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (中国标准时间)");
        let endDay = moment(this.value1, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (中国标准时间)");
        let startTime = this.startTime.split(":").map(Number);
        let endTime = this.endTime.split(":").map(Number);
        startDay = startDay.add(startTime[0], "hours").add(startTime[1], "minutes");
        this.ordMain.tarriveReq = startDay.format("YYYY-MM-DD HH:mm");
        endDay = endDay.add(endTime[0], "hours").add(endTime[1], "minutes");
        this.ordMain.tarriveEnd = endDay.format("YYYY-MM-DD HH:mm");
      }
    },
    /**
     * 选中收货地址
     * @param val
     */
    changeInfo(val) {
      this.ordMain.ccustomerAddr = val.name;
      this.ordMain.creceiveAddr = val.address;
      this.ordMain.caddrLongitude = val.location.lng;
      this.ordMain.caddrLatitude = val.location.lat;
    },
    /**
     * 获取收货地址
     * @param val
     */
    getReceivingAddress(val) {
      var self = this;
      var map = new AMap.Map("container", {
        resizeEnable: true, //是否监控地图容器尺寸变化
        zoom: 11, //初始地图级别
      });
      var keywords = val;
      AMap.plugin("AMap.AutoComplete", function () {
        var autoOptions = {
          city: self.value,
        };
        var autoComplete = new AMap.AutoComplete(autoOptions);
        autoComplete.search(keywords, function (status, result) {
          if (status === "complete" && result.info === "OK") {
            // 搜索成功时，result即是对应的匹配数据
            self.infoOptions = result.tips.filter((city) => city.id !== null && city.id !== "");
          }
        });
      });
    },
    selectOrderById() {
        let ordMain = this.orderInfo;
        this.$set(this.ordMain, "sid", ordMain.sid);
        this.$set(this.ordMain, "sshop", ordMain.sshop);
        this.$set(this.ordMain, "ccustomerAddr", ordMain.ccustomerAddr);
        this.$set(this.ordMain, "creceiveAddr", ordMain.creceiveAddr);
        this.$set(this.ordMain, "ccustomerName", ordMain.ccustomerName);
        this.$set(this.ordMain, "ccustomerPhone", ordMain.ccustomerPhone);
        this.$set(this.ordMain, "caddrLongitude", ordMain.caddrLongitude);
        this.$set(this.ordMain, "caddrLatitude", ordMain.caddrLatitude);
        this.$set(this.ordMain, "cremark", ordMain.cremark);
        this.$set(this.ordMain, "corderRemark", ordMain.corderRemark);
        this.store = ordMain.rstore;
        this.topsAjax.get(`${this.baseUrls.shop}/getById/${ordMain.rshop}`).then((res) => {
          this.address.push(res.cprovincial);
          this.address.push(res.ccity);
          this.address.push(res.carea);

          this.queryStore(ordMain.sid, res.ccity)
        });
        
    }
  }
};
</script>

<style lang="scss">
.amap-sug-result {
  z-index: 9999;
}

.orderInfoAD {
  width: 100%;

  .el-input {
    width: 270px;
  }

  .el-picker-panel__body > .el-date-picker__time-header > .el-date-picker__editor-wrap > .el-input {
    width: 100% !important;
  }

  .orderGoodsAddDialog {
    .el-date-picker__time-header > div {
      width: 100% !important;
    }

    .el-dialog__body {
      background-color: white !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.el-select-dropdown__item {
  height: auto;
}
</style>
